/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStateKey } from '@angular/core';

export const CAMPAIGNDATA_KEY = makeStateKey<any>('campaignData');
export const CAMPAIGNPARTICIPANTID_KEY = makeStateKey<any>('campaignParticipantId');
export const REDIRECTURL_KEY = makeStateKey<string>('redirectUrl');
export const INACTIVEPAGE_KEY = makeStateKey<any>('inactivePage');
export const LOG_KEY = makeStateKey<string>('log');
export const CAMPAIGNFOUND_KEY = makeStateKey<boolean>('campaignFound');
export const SHAREIMAGEURL_KEY = makeStateKey<string>('shareImageUrl');
export const ISBOT_KEY = makeStateKey<boolean>('isBot');
export const ISSHORTLINK_KEY = makeStateKey<boolean>('isShortLink');
export const ISERROR_KEY = makeStateKey<boolean>('isError');
export const ERRORMESSAGE_KEY = makeStateKey<string>('errorMessage');
export const REQUESTURL_KEY = makeStateKey<string>('requestUrl');
export const REQUESTPARSE_KEY = makeStateKey<any>('requestParse');
export const CAMPAIGNLOOKUPURL_KEY = makeStateKey<string>('campaignLookupUrl');

export const BUZZWAVE_REDIRECT_URL = 'https://buzzwave.io';

export const GUID_REGEX =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
